var Rating = function () {
    $('.rating-box .star').on('click', function () {
        var $button = $(this);
        var $box = $button.closest('.rating-box');
        var $stars = $box.find('.stars');
        if ($stars.data('pending') || $stars.data('submitted')) return;
        var rating = $button.data('rating-value') || $button.index() + 1;
        var $buttons = $stars.find('.star');
        var $error = $box.find('.rating-error');
        $stars.data('pending', true).attr('aria-busy', 'true');
        $buttons.prop('disabled', true);
        $error.prop('hidden', true).text('');
        function failed() {
            $error.text('Din röst kunde inte sparas. Försök igen.').prop('hidden', false);
        }
        $.get('/rating/add/' + rating + '/' + $stars.data('page'))
            .done(function (response) {
                if (String(response).trim() !== 'OK') { failed(); return; }
                $stars.data('submitted', true);
                var $count = $box.find('.count');
                $count.text(parseInt($count.text(), 10) + 1);
                $box.find('.thanks').show();
            })
            .fail(failed)
            .always(function () {
                $stars.data('pending', false).attr('aria-busy', 'false');
                $buttons.prop('disabled', !!$stars.data('submitted'));
            });
    });
};
module.exports = Rating;
